(ns iris.analytics.views.page-views
  (:require
   [re-frame.core :as re-frame]
   [iris.subs :as subs]))



(defonce page-views-report-urls {:tlo "https://lookerstudio.google.com/embed/reporting/002192f8-2ad7-4298-aa12-6971d6c548d5/page/2h8pD"
                                 :tsc "https://lookerstudio.google.com/embed/reporting/aa9ab7b6-bac7-4e3d-8782-71a46c91d066/page/9j8pD"
                                 :stk "https://lookerstudio.google.com/embed/reporting/df8af372-7e0f-491e-9988-8ecb3ad25935/page/RR6pD"})


(defn page-views-report-iframe [url]
  [:iframe
   {:width "100%"
    :height "100%"
    :scrolling "no"
    :src url
    :frameBorder "0"
    :style {:border "0" :position "absolute" :margin-top "20px"}
    :allowFullScreen ""
    :sandbox
    "allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"}])

(defn page-views-report []
  (let [ws @(re-frame/subscribe [::subs/ws])]
    (cond
      (= ws "TLO")
      [page-views-report-iframe (:tlo page-views-report-urls)]
      (= ws "STK")
      [page-views-report-iframe (:stk page-views-report-urls)]
      (= ws "TSC")
      [page-views-report-iframe (:tsc page-views-report-urls)])))